import { render, staticRenderFns } from "./SubmitAndCancel.vue?vue&type=template&id=24427034&scoped=true"
import script from "./SubmitAndCancel.js?vue&type=script&lang=js&external"
export * from "./SubmitAndCancel.js?vue&type=script&lang=js&external"
import style0 from "./SubmitAndCancel.scss?vue&type=style&index=0&id=24427034&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24427034",
  null
  
)

export default component.exports